import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'mobx-react';
import { observer } from 'mobx-react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from 'react-router-dom';
import colors from 'tailwindcss/colors';
import './App.scss';
import ProtectedRoute from './Components/ProtectedRoute';

import appStore from './appStore';
import Header from './Header';
import Dashboard from './Dashboard';
import Login from './Login/Login';
import ResetPassword from './Login/ResetPassword';
import Profile from './Profile/';
import LoginSuccess from './Login/Success';
import {
  OrganizationCodePage,
  RegistrationFormPage,
  RegistrationSuccessPage,
} from './Login/Registration';
import {
  SubscriptionSetup,
  SubscriptionSuccess,
  SubscriptionManagement,
} from './Login/Subscription';
import InfinitePractice from './Components/InfinitePractice';
import PodcastList from './Components/auto/Podcasts/PodcastsGallery';
// import AddQuestion from './Components/auto/Admin';
import VideoGallery2 from './Components/auto/video_gallery/VideoGallery';
import VideoGallery from './Components/auto/Videos/VideoGallery';
import DrivingSessionsGallery from './Components/auto/DrivingSession/DrivingSessionsGallery';
import StudentDashboard from './Components/auto/ExamSimulator/StudentDashboard';
import ChatWindow from './Components/auto/ChatWindow';

// Initialize Stripe with the publishable key that was passed during build
const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
if (!stripeKey) {
  console.error('ERROR: Missing Stripe key (REACT_APP_STRIPE_PUBLISHABLE_KEY)');
}

// Initialize Stripe with the publishable key
const stripePromise = loadStripe(stripeKey);

// Log which key is being used (removed in production builds)
if (process.env.NODE_ENV !== 'production') {
  console.log(
    `Environment: ${process.env.REACT_APP_ENV || process.env.NODE_ENV}`
  );
  console.log(
    `Stripe key starts with: ${stripeKey ? stripeKey.substring(0, 8) + '...' : 'MISSING KEY'}`
  );
  console.log(
    `Key type: ${stripeKey?.startsWith('pk_test_') ? 'TEST KEY' : 'LIVE KEY'}`
  );
}

@observer
class App extends Component {
  render() {
    return (
      <ThemeProvider theme={colors}>
        {/* Provide the singleton store to the whole app */}
        <Provider store={appStore}>
          <Elements stripe={stripePromise}>
            <Router>
              {/* If store.redirect has a value, redirect to it */}
              {appStore.redirect ? <Redirect to={appStore.redirect} /> : null}

              {/* If user is logged in, show main routes; otherwise show login */}
              {appStore.isLoggedIn ? (
                <>
                  {/* Conditionally render ChatWindow if the Chat module is enabled */}
                  {appStore.orgSettings?.modulos?.TeoriaPermisoB?.children?.Chat
                    ?.enabled && <ChatWindow />}
                  <Switch>
                    <Route path="/writing/document">
                      <div />
                    </Route>
                    <Route component={Header} />
                  </Switch>

                  <Switch>
                    {/* Subscription and profile routes - accessible after login but without requiring a complete subscription */}
                    <Route
                      path="/student/subscriptions/setup"
                      component={SubscriptionSetup}
                    />
                    <Route
                      path="/student/subscriptions/success"
                      component={SubscriptionSuccess}
                    />
                    <Route
                      path="/student/subscriptions/status"
                      component={SubscriptionManagement}
                    />
                    <Route path="/my-profile" component={Profile} />
                    <Route path="/signup/success" component={LoginSuccess} />
                    <Route path="/signup/failed" component={Profile} />

                    {/* Protected routes - require completed subscription */}
                    <ProtectedRoute path="/" exact component={Dashboard} />
                    <ProtectedRoute
                      path="/api/v1/infinite_practice"
                      component={InfinitePractice}
                    />
                    {/* Legacy route kept for backward compatibility */}
                    <ProtectedRoute
                      path="/auto/infinite-practice"
                      component={InfinitePractice}
                    />
                    <ProtectedRoute
                      path="/auto/video-gallery"
                      component={VideoGallery2}
                    />
                    <ProtectedRoute
                      path="/auto/videos"
                      component={VideoGallery}
                    />
                    <ProtectedRoute
                      path="/auto/examen"
                      component={StudentDashboard}
                    />
                    <ProtectedRoute
                      path="/auto/podcasts"
                      component={PodcastList}
                    />
                    <ProtectedRoute
                      path="/auto/driving"
                      component={DrivingSessionsGallery}
                    />
                  </Switch>
                </>
              ) : (
                <>
                  <Switch>
                    <Route path="/" exact>
                      <Redirect to="/login" />
                    </Route>
                    <Route
                      path="/register"
                      exact
                      component={OrganizationCodePage}
                    />
                    <Route
                      path="/register/form"
                      component={RegistrationFormPage}
                    />
                    <Route
                      path="/register/success"
                      component={RegistrationSuccessPage}
                    />
                    <Route path="/reset-password" component={ResetPassword} />
                    <Route path="/" component={Login} />
                  </Switch>
                </>
              )}
            </Router>
          </Elements>
        </Provider>
      </ThemeProvider>
    );
  }
}

export default App;
